//# sourceMappingURL=my-marked-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/dist/interfaces/my-marked-date.interface.js
// module id = 580
// module chunks = 10